/**
 * CSS `cursor` value showing `svg` as the pointer image, with its
 * hotspot at `hotspot` and `fallback` where custom cursors are not
 * supported.
 */
export function svgCursorStyle(
    svg: string,
    hotspot: { x: number; y: number },
    fallback: string
): string {
    const base64Cursor = `data:image/svg+xml;base64,${btoa(svg)}`;
    return `url(${base64Cursor}) ${hotspot.x} ${hotspot.y}, ${fallback}`;
}
